function onDocumentReady() {
    if( $().magnificPopup) {
        $('.video-link').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false
        });
        $('.resource-type-videos').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false
        });
    }
}
$(onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/magnific-controller.js